module.exports = __webpack_public_path__ + "static/media/project1.50b683bd.png";